import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import get from 'lodash/get';
export default {
  name: 'CoreDtwinRuleEditGeoFences',
  props: {
    rule: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {};
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme'])), {}, {
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    requiredRule: function requiredRule() {
      var _this = this;

      return [function (v) {
        return !!v || parseInt(v) === 0 || _this.$i18n_t('Common.fieldRequired');
      }];
    },
    distanceRules: function distanceRules() {
      var _this2 = this;

      return [function (v) {
        return !!v && (isNaN(parseFloat(v)) || parseFloat(v) <= 0 ? _this2.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.geoFences.numberRule') : true) || _this2.$i18n_t('Common.fieldRequired');
      }];
    },
    hourRules: function hourRules() {
      var _this3 = this;

      return [function (v) {
        return !!v && (isNaN(parseFloat(v)) || parseFloat(v) <= 0 ? _this3.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.geoFences.numberRule') : true) || _this3.$i18n_t('Common.fieldRequired');
      }];
    },
    geoFences: function geoFences() {
      return get(this.rule, 'properties.geoFences') || [];
    }
  }),
  watch: {},
  methods: {
    geoFenceFilter: function geoFenceFilter(twin) {
      return ['zone', 'floor', 'building'].indexOf((twin.data.type || '').toLowerCase()) >= 0 && twin.hasPolygon;
    }
  }
};